module.exports = __webpack_public_path__ + "img/mobile_link.fe1dda06.png";